module.exports = __webpack_public_path__ + "static/media/Guzzlord_gaussian2.cb5f48db.png";